import { InputMultiSelectInner } from '@components/InputMultiSelect/InputMultiSelectInner';

interface Option {
  label: string;
  value: string;
}

interface EnumMultiSelectProps {
  options: Option[];
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  dataTestId?: string;
}

export function EnumMultiSelect({
  options,
  values,
  onChange,
  placeholder = 'Set a value',
  dataTestId,
}: Readonly<EnumMultiSelectProps>) {
  return (
    <InputMultiSelectInner
      dataTestId={dataTestId}
      dropdownInnerWrapperClassName="flex flex-nowrap items-center py-0"
      dropdownWrapperClassName="w-full"
      multiSelectDropdownClasses="w-full min-w-0 bg-white"
      isSearchable
      onChange={(vals, _name) => onChange(vals ?? [])}
      options={options.map((o) => ({ name: o.label, value: o.value }))}
      placeholder={placeholder}
      remainingTriggerClassName="shrink-0 rounded-md py-1 -my-1 pl-2 pr-2"
      selectedItemClassName="max-w-[min(180px,100%)] shrink-0 rounded-md py-1 -my-1 pl-2 pr-2 mr-1"
      selectedItemLabelClassName="min-w-0 truncate"
      shouldRenderInsidePortal
      value={values}
    />
  );
}
